import * as React from 'react';
import { Dispatch } from 'react-redux';
import { StoreState } from '../../../../reducers';
import Utils from '../../../../utils';
import { SearchButtonContainer, StyledSearchButton } from './styles';
import UserAgentUtils from '../../../../utils/userAgent';
import Tooltip from '../../../Tooltip';
import { toggleSearchFieldVisibility } from '../../../../containers/DriveItemList/Search/actions';

interface SearchButtonProps {
	isActive: boolean;
	dispatch: Dispatch<StoreState>;
}

class SearchButton extends React.Component<SearchButtonProps, {}> {
	constructor(props: SearchButtonProps) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
	}

	render() {
		const { isActive } = this.props;
		const tooltipId = Utils.generateId();

		return (
			<SearchButtonContainer>
				<StyledSearchButton
					onClick={this.handleClick}
					data-tip={true}
					data-for={tooltipId}
					isActive={isActive}
				>
					{Utils.getSvgIcon(`iconset_uprez_search`)}
					{UserAgentUtils.isDesktop() && <Tooltip id={tooltipId} text={'messages.search'} />}
				</StyledSearchButton>
			</SearchButtonContainer>
		);
	}

	private handleClick(): void {
		const { dispatch } = this.props;
		dispatch(toggleSearchFieldVisibility());
	}
}

export default SearchButton;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItemList/Search/Button/index.tsx